import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { HomeComponent } from './home/home.component';
import { AuthenticationGuard } from './auth/authentication.guard';
import { NavigationComponent } from './navigation/navigation.component';




const routes: Routes = [
  { 
    path: 'home',
    component: HomeComponent,
    children:
    [
      {
        path:'login',
        loadChildren:() => import('@app/login-dialog/login-dialog.module').then( m => m['LoginDialogModule'] ),
      }
    ]
  },
  { 
    path: '',
    component: NavigationComponent,
    canActivate: [ AuthenticationGuard ],
  },
  { 
    path: '**', 
    redirectTo: '' 
  },
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [
    RouterModule
  ],
  providers: [],
})

export class AppRoutingModule {
  constructor(){
  }
}


